module.exports = __webpack_public_path__ + "img/collage_collage.00367a0.svg";